/* MoRetro Studio V18.4.6 — Prix atelier + sauvegarde projet fiable
   Prix basé sur :
   - temps impression heure/min
   - prix matière première €/kg
   - poids
   - marge %
   - coût électricité €/h
   - main d'œuvre unique
   - imprimante utilisée
   - matière utilisée

   Important : si tout est à 0, le prix tombe à 0.
*/
window.MTS = window.MTS || {};

(function(MTS){
  "use strict";

  const DEFAULTS = {
    material:"PLA",
    printer:"P2S #1",
    filamentKgPrice:23,
    electricityHourly:0.25,
    laborFixed:10,
    marginPercent:30,
    finalPrice:""
  };

  function getSettings(){
    try { return {...DEFAULTS, ...(JSON.parse(localStorage.getItem("moretroQuoteSettings") || "{}"))}; }
    catch(e){ return {...DEFAULTS}; }
  }

  function saveSettings(settings){
    try { localStorage.setItem("moretroQuoteSettings", JSON.stringify(settings)); } catch(e){}
  }

  function num(id, fallback=0){
    const el = MTS.$(id);
    const raw = el ? String(el.value || "").replace(",", ".") : "";
    const value = parseFloat(raw);
    return Number.isFinite(value) ? value : fallback;
  }

  function val(id, fallback=""){
    const el = MTS.$(id);
    return el ? String(el.value || fallback).trim() : fallback;
  }

  function printableFiles(project){
    if(!Array.isArray(project.files)) return [];
    return project.files.filter(f=>{
      const n = String(f.name || "").toLowerCase();
      return /\.(stl|3mf|obj|gcode|bgcode|step|stp|amf|ply|wrl|x3d)$/i.test(n);
    });
  }

  function fileKey(f, index){
    return String(f.path || f.url || f.name || index);
  }

  function selectedFile(project){
    const files = printableFiles(project);
    if(!files.length) return null;
    const wanted = MTS.$("mtsManualFileSelect")?.value || "";
    return files.find((f,i)=>fileKey(f,i) === wanted) || files[files.length - 1];
  }

  function renderFileSelect(files, selectedKey=""){
    if(!files.length){
      return `
        <div class="mts-manual-file-box">
          <strong>Aucun fichier 3D détecté</strong>
          <span>Tu peux quand même faire un devis manuel.</span>
        </div>
      `;
    }

    const current = selectedKey || fileKey(files[files.length - 1], files.length - 1);

    return `
      <label>Fichier client
        <select id="mtsManualFileSelect">
          ${files.map((f,i)=>{
            const key = fileKey(f,i);
            const size = f.size && MTS.Files ? " • " + MTS.Files.fileSizeLabel(f.size) : "";
            return `<option value="${MTS.escapeHtml(key)}" ${key===current?"selected":""}>${MTS.escapeHtml(f.name || "Fichier 3D")}${MTS.escapeHtml(size)}</option>`;
          }).join("")}
        </select>
      </label>
    `;
  }

  function collectManual(){
    const hours = num("mtsManualHours", 0);
    const minutes = num("mtsManualMinutes", 0);

    return {
      dimX:num("mtsManualX",0),
      dimY:num("mtsManualY",0),
      dimZ:num("mtsManualZ",0),
      weightG:num("mtsManualWeight",0),
      hours,
      minutes,
      printHours: Math.max(0, hours + minutes / 60),

      material:val("mtsAutoMaterial","PLA"),
      printer:val("mtsAutoPrinter","P2S #1"),
      filamentId:val("mtsAutoFilament",""),

      filamentKgPrice:num("mtsFilamentKgPrice",23),
      electricityHourly:num("mtsElectricityHourly",0.25),
      laborFixed:num("mtsLaborFixed",10),
      marginPercent:num("mtsMarginPercent",30),
      finalPrice:num("mtsFinalPrice",0)
    };
  }

  function calculate(manual){
    const weightG = Math.max(0, Number(manual.weightG || 0));
    const printHours = Math.max(0, Number(manual.printHours || 0));

    const materialCost = (weightG / 1000) * Number(manual.filamentKgPrice || 0);
    const electricityCost = printHours * Number(manual.electricityHourly || 0);
    const laborCost = Number(manual.laborFixed || 0);

    const baseCost = materialCost + electricityCost + laborCost;
    const marginAmount = baseCost * (Number(manual.marginPercent || 0) / 100);
    const suggested = baseCost + marginAmount;

    const final = Number(manual.finalPrice || 0) > 0 ? Number(manual.finalPrice) : suggested;

    return {
      weightG,
      printHours,
      materialCost,
      electricityCost,
      laborCost,
      baseCost,
      marginAmount,
      suggested,
      final
    };
  }

  function buildAutoQuote(project){
    const manual = collectManual();
    const existingQuoteNumber = project?.autoQuote?.quoteNumber || project?.quote?.quoteNumber || safeQuoteNumber();
    const file = selectedFile(project);
    const files = printableFiles(project);
    const q = calculate(manual);
    const bboxVolumeCm3 = Math.max(0, manual.dimX * manual.dimY * manual.dimZ / 1000);

    return {
      fileName:file?.name || "Saisie manuelle",
      fileType:file?.ext ? String(file.ext).replace(".","").toUpperCase() : (file?.name ? String(file.name).split(".").pop().toUpperCase() : "MANUEL"),
      fileKey:file ? fileKey(file, files.indexOf(file)) : "",
      manual,
      analysis:{
        analyzable:true,
        manual:true,
        dimensions:{x:manual.dimX, y:manual.dimY, z:manual.dimZ},
        volumeCm3:bboxVolumeCm3,
        bboxVolumeCm3,
        triangles:0,
        metadata:{
          source:"Saisie manuelle depuis slicer",
          printer:manual.printer,
          filament:manual.material,
          filamentId:manual.filamentId,
          filamentName:(MTS.Settings && MTS.Settings.filamentById && manual.filamentId) ? (MTS.Settings.filamentById(manual.filamentId)?.name || "") : ""
        }
      },
      quote:{
        effectiveVolumeCm3:bboxVolumeCm3,
        weightG:q.weightG,
        filamentCost:q.materialCost,
        materialCost:q.materialCost,
        electricityCost:q.electricityCost,
        printHours:q.printHours,
        machineCost:q.electricityCost,
        laborCost:q.laborCost,
        realCost:q.baseCost,
        baseCost:q.baseCost,
        marginAmount:q.marginAmount,
        marginPercent:manual.marginPercent,
        suggested:q.suggested,
        final:q.final
      },
      settings:manual,
      quoteNumber: existingQuoteNumber,
      createdAt:new Date().toISOString()
    };
  }

  function renderMetadata(meta){
    if(!meta) return "";
    const rows = [
      ["Source", meta.source],
      ["Imprimante", meta.printer],
      ["Matière", meta.filament],
      ["Bobine", meta.filamentName]
    ].filter(([,v])=>v !== undefined && v !== null && v !== "");

    if(!rows.length) return "";

    return `
      <div class="mts-analysis-meta">
        ${rows.map(([k,v])=>`<div><span>${MTS.escapeHtml(k)}</span><strong>${MTS.escapeHtml(v)}</strong></div>`).join("")}
      </div>
    `;
  }

  function formatTime(hours){
    const totalMin = Math.round(Number(hours || 0) * 60);
    const h = Math.floor(totalMin / 60);
    const m = totalMin % 60;
    return `${h} h ${String(m).padStart(2,"0")} min`;
  }

  function renderAnalysis(data){
    const a = data.analysis || {};
    const q = data.quote || {};
    const d = a.dimensions || {};
    const price = Number(q.final || q.suggested || 0);

    return `
      <div class="mts-client-quote" data-quote-total="${MTS.escapeHtml(price)}">
        <div class="mts-client-quote-main">
          <span>Prix final client</span>
          <strong>${MTS.money(price)}</strong>
        </div>

        <div class="mts-client-quote-sub">
          <div><span>Fichier</span><strong>${MTS.escapeHtml(data.fileName || "—")}</strong></div>
          <div><span>Imprimante</span><strong>${MTS.escapeHtml(a.metadata?.printer || "—")}</strong></div>
          <div><span>Matière</span><strong>${MTS.escapeHtml(a.metadata?.filament || "—")}</strong></div>
          <div><span>Dimensions</span><strong>${MTS.round1(d.x)} × ${MTS.round1(d.y)} × ${MTS.round1(d.z)} mm</strong></div>
          <div><span>Poids</span><strong>${MTS.round1(q.weightG)} g</strong></div>
          <div><span>Temps</span><strong>${formatTime(q.printHours)}</strong></div>
        </div>

        ${renderMetadata(a.metadata)}

        <details class="mts-internal-costs">
          <summary>Détails internes de calcul</summary>
          <div class="mts-price-line"><span>Matière première</span><strong>${MTS.money(q.materialCost)}</strong></div>
          <div class="mts-price-line"><span>Électricité</span><strong>${MTS.money(q.electricityCost)}</strong></div>
          <div class="mts-price-line"><span>Main d’œuvre unique</span><strong>${MTS.money(q.laborCost)}</strong></div>
          <div class="mts-price-line"><span>Coût de base</span><strong>${MTS.money(q.baseCost)}</strong></div>
          <div class="mts-price-line"><span>Marge ${MTS.round1(q.marginPercent)}%</span><strong>${MTS.money(q.marginAmount)}</strong></div>
          <div class="mts-price-line"><span>Prix conseillé</span><strong>${MTS.money(q.suggested)}</strong></div>
        </details>
      </div>
    `;
  }


  function settingsDefaults(){
    const s = MTS.state.settings || {};
    return {
      material:s.quoteDefaults?.material || DEFAULTS.material,
      filamentKgPrice:Number(s.quoteDefaults?.filamentKgPrice || DEFAULTS.filamentKgPrice),
      electricityHourly:Number(s.quoteDefaults?.electricityHourly || DEFAULTS.electricityHourly),
      laborFixed:Number(s.quoteDefaults?.laborFixed || DEFAULTS.laborFixed),
      marginPercent:Number(s.quoteDefaults?.marginPercent || DEFAULTS.marginPercent),
      printer:(MTS.Settings?.activePrinters?.()[0]?.name) || DEFAULTS.printer
    };
  }

  function printerSelectOptions(selected){
    if(MTS.Settings && typeof MTS.Settings.printerOptions === "function"){
      return MTS.Settings.printerOptions(selected);
    }

    return `
      <option ${selected==="Ender 3 V3 SE #1"?"selected":""}>Ender 3 V3 SE #1</option>
      <option ${selected==="Ender 3 V3 SE #2"?"selected":""}>Ender 3 V3 SE #2</option>
      <option ${selected==="Sidewinder X4 Plus"?"selected":""}>Sidewinder X4 Plus</option>
      <option ${selected==="Kobra S1"?"selected":""}>Kobra S1</option>
      <option ${selected==="P2S #1"?"selected":""}>P2S #1</option>
      <option ${selected==="P2S #2"?"selected":""}>P2S #2</option>
      <option ${selected==="H2D"?"selected":""}>H2D</option>
    `;
  }

  function filamentSelectOptions(selected){
    if(MTS.Settings && typeof MTS.Settings.filamentOptions === "function"){
      const options = MTS.Settings.filamentOptions(selected);
      return `<option value="">Aucune bobine précise</option>` + options;
    }
    return `<option value="">Aucune bobine précise</option>`;
  }

  function materialSelectOptions(selected){
    if(MTS.Settings && typeof MTS.Settings.materialOptions === "function"){
      return MTS.Settings.materialOptions(selected);
    }

    return `
      <option value="PLA" ${selected==="PLA"?"selected":""}>PLA</option>
      <option value="PETG" ${selected==="PETG"?"selected":""}>PETG</option>
      <option value="ABS" ${selected==="ABS"?"selected":""}>ABS</option>
      <option value="ASA" ${selected==="ASA"?"selected":""}>ASA</option>
      <option value="TPU" ${selected==="TPU"?"selected":""}>TPU</option>
      <option value="RESINE" ${selected==="RESINE"?"selected":""}>Résine</option>
    `;
  }


  function renderQuoteBox(project){
    const saved = project.autoQuote || null;
    const settings = {...getSettings(), ...settingsDefaults(), ...(saved?.settings || saved?.manual || {})};
    const files = printableFiles(project);
    const savedHours = settings.hours ?? Math.floor(settings.printHours || 0);
    const savedMinutes = settings.minutes ?? Math.round(((settings.printHours || 0) % 1) * 60);

    return `
      <div class="mts-quote-auto mts-manual-quote">
        <h4>💰 Devis atelier manuel</h4>
        <p class="mts-muted">Renseigne les valeurs du slicer. Si toutes les valeurs sont à 0, le prix tombe à 0.</p>

        <div class="mts-quote-profiles">
          ${renderFileSelect(files, saved?.fileKey || "")}

          <label>Dimension X mm<input type="number" step="0.1" min="0" id="mtsManualX" value="${MTS.escapeHtml(settings.dimX || 0)}"></label>
          <label>Dimension Y mm<input type="number" step="0.1" min="0" id="mtsManualY" value="${MTS.escapeHtml(settings.dimY || 0)}"></label>
          <label>Dimension Z mm<input type="number" step="0.1" min="0" id="mtsManualZ" value="${MTS.escapeHtml(settings.dimZ || 0)}"></label>

          <label>Poids g<input type="number" step="0.1" min="0" id="mtsManualWeight" value="${MTS.escapeHtml(settings.weightG || 0)}"></label>
          <label>Temps heures<input type="number" step="1" min="0" id="mtsManualHours" value="${MTS.escapeHtml(savedHours || 0)}"></label>
          <label>Temps minutes<input type="number" step="1" min="0" max="59" id="mtsManualMinutes" value="${MTS.escapeHtml(savedMinutes || 0)}"></label>

          <label>Imprimante<select id="mtsAutoPrinter">
            ${printerSelectOptions(settings.printer)}
          </select></label>

          <label>Matière<select id="mtsAutoMaterial">
            ${materialSelectOptions(settings.material)}
          </select></label>

          <label>Bobine<select id="mtsAutoFilament">
            ${filamentSelectOptions(settings.filamentId || "")}
          </select></label>

          <label>Prix matière €/kg<input type="number" step="0.01" min="0" id="mtsFilamentKgPrice" value="${MTS.escapeHtml(settings.filamentKgPrice ?? 23)}"></label>
          <label>Électricité €/h<input type="number" step="0.01" min="0" id="mtsElectricityHourly" value="${MTS.escapeHtml(settings.electricityHourly ?? 0.25)}"></label>
          <label>Main d’œuvre unique €<input type="number" step="0.01" min="0" id="mtsLaborFixed" value="${MTS.escapeHtml(settings.laborFixed ?? 10)}"></label>
          <label>Marge %<input type="number" step="1" min="0" id="mtsMarginPercent" value="${MTS.escapeHtml(settings.marginPercent ?? 30)}"></label>
          <label>Prix final forcé €<input type="number" step="0.01" min="0" id="mtsFinalPrice" value="${MTS.escapeHtml(settings.finalPrice || "")}" placeholder="vide = calcul auto"></label>
        </div>

        <div class="mts-actions">
          <button class="mts-btn mts-ok" type="button" id="mtsAnalyzeFile">Calculer le devis</button>
          <button class="mts-btn mts-soft" type="button" id="mtsSaveAutoQuote">Enregistrer le devis</button>
          <button class="mts-btn mts-soft" type="button" id="mtsGenerateQuotePdf">Générer le devis PDF</button>
          <button class="mts-btn mts-soft" type="button" data-shopify-action="create">Créer devis Shopify</button>
          <button class="mts-btn mts-ok" type="button" data-shopify-action="send">Envoyer devis + lien</button>
        </div>

        <div class="mts-analysis-card" id="mtsAnalysisCard">
          ${saved ? renderAnalysis(saved) : "Renseigne les valeurs puis clique sur “Calculer le devis”."}
        </div>
      </div>
    `;
  }

  function refresh(project){
    const card = MTS.$("mtsAnalysisCard");
    const data = buildAutoQuote(project || {});
    MTS.state.lastAutoQuote = data;
    saveSettings(data.settings);
    if(card) card.innerHTML = renderAnalysis(data);
  }

  async function analyzeProject(project){
    refresh(project);
  }


  function quotePdfFileRecord(project, data){
    const q = data.quote || {};
    const price = Number(q.final || q.suggested || 0);
    const quoteNumber = data.quoteNumber || safeQuoteNumber();

    return {
      id:`quote-pdf-${quoteNumber}`,
      type:"quote_pdf",
      documentType:"quote_pdf",
      category:"documents",
      icon:"📄",
      name:`Devis PDF ${quoteNumber}`,
      title:"Devis PDF",
      description:"Devis atelier PDF généré depuis MoRetro Studio",
      amount:price || "",
      price:price || "",
      quoteNumber,
      createdAt:new Date().toISOString()
    };
  }

  async function save(projectId){
    const project = MTS.state.projects.find(p=>p.id===projectId) || {};
    refresh(project);

    if(!MTS.state.lastAutoQuote) throw new Error("Calcule d'abord un devis.");

    const finalPrice = Number(MTS.state.lastAutoQuote.quote.final || MTS.state.lastAutoQuote.quote.suggested || 0);
    const printMinutes = Math.round(Number(MTS.state.lastAutoQuote.quote.printHours || 0) * 60);
    const printerName = MTS.state.lastAutoQuote.analysis?.metadata?.printer || MTS.state.lastAutoQuote.settings?.printer || "";

    const update = {
      autoQuote:MTS.state.lastAutoQuote,
      finalPrice,
      quoteTotal:finalPrice,
      printerName,
      printEstimatedMinutes:printMinutes,
      quote:{
        price:finalPrice,
        total:finalPrice,
        final:finalPrice,
        quoteNumber:MTS.state.lastAutoQuote.quoteNumber,
        realCost:MTS.state.lastAutoQuote.quote.realCost,
        material:MTS.state.lastAutoQuote.quote.materialCost,
        electricity:MTS.state.lastAutoQuote.quote.electricityCost,
        labor:MTS.state.lastAutoQuote.quote.laborCost,
        margin:MTS.state.lastAutoQuote.quote.marginAmount,
        updatedAt:firebase.firestore.FieldValue.serverTimestamp()
      },
      files:firebase.firestore.FieldValue.arrayUnion(quotePdfFileRecord(project, MTS.state.lastAutoQuote)),
      updatedAt:firebase.firestore.FieldValue.serverTimestamp(),
      history: firebase.firestore.FieldValue.arrayUnion({
        type:"quote_saved",
        label:"Devis atelier enregistré",
        date:new Date().toISOString()
      })
    };

    if(MTS.Workflow && typeof MTS.Workflow.saveQuote === "function"){
      await MTS.Workflow.saveQuote(project, MTS.state.lastAutoQuote);
    }else{
      await MTS.state.db.collection("custom_requests").doc(projectId).set(update, { merge:true });
    }

    Object.assign(project, {
      ...update,
      updatedAt:new Date().toISOString(),
      autoQuote:MTS.state.lastAutoQuote,
      finalPrice,
      quoteTotal:finalPrice,
      printerName,
      printEstimatedMinutes:printMinutes,
      quote:{
        ...(project.quote || {}),
        price:finalPrice,
        total:finalPrice,
        final:finalPrice,
        quoteNumber:MTS.state.lastAutoQuote.quoteNumber
      }
    });

    if(MTS.Projects && typeof MTS.Projects.renderDetail === "function") MTS.Projects.renderDetail(project);
    if(MTS.Projects && typeof MTS.Projects.renderList === "function") MTS.Projects.renderList();
  }

  function safeQuoteNumber(){
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth()+1).padStart(2,"0");
    const day = String(d.getDate()).padStart(2,"0");
    const rand = Math.floor(1000 + Math.random()*9000);
    return `DEV-${y}${m}${day}-${rand}`;
  }

  function buildQuoteHtml(project, data){
    const a = data.analysis || {};
    const q = data.quote || {};
    const d = a.dimensions || {};
    const quoteNumber = data.quoteNumber || safeQuoteNumber();
    const created = new Date().toLocaleDateString("fr-FR");
    const finalPrice = MTS.money(q.final || q.suggested);
    const fileName = MTS.escapeHtml(data.fileName || "Projet sur mesure");
    const projectName = MTS.escapeHtml(project.projectType || "Projet sur mesure");
    const clientName = MTS.escapeHtml(project.name || "Client");
    const clientEmail = MTS.escapeHtml(project.email || "");
    const clientPhone = MTS.escapeHtml(project.phone || "");
    const description = MTS.escapeHtml(project.message || "");
    const dimensions = `${MTS.round1(d.x)} × ${MTS.round1(d.y)} × ${MTS.round1(d.z)} mm`;
    const weight = `${MTS.round1(q.weightG)} g`;
    const time = formatTime(q.printHours);

    return `<!doctype html>
<html lang="fr">
<head>
<meta charset="utf-8">
<title>Devis ${quoteNumber} - MoRetro 3D</title>
<style>
  @page{size:A4;margin:14mm}
  *{box-sizing:border-box}
  body{margin:0;background:#f3f3f5;color:#202124;font-family:Arial,Helvetica,sans-serif;-webkit-print-color-adjust:exact;print-color-adjust:exact}
  .page{max-width:760px;margin:24px auto;background:#fff;border-radius:24px;overflow:hidden;box-shadow:0 18px 55px rgba(0,0,0,.10)}
  .topline{height:8px;background:linear-gradient(90deg,#ff2b2b,#7b2cff,#00d4ff)}
  .inner{padding:34px}
  .header{text-align:center;padding-bottom:24px}
  .logo{width:58px;height:58px;margin:0 auto 14px;border-radius:16px;display:grid;place-items:center;color:#fff;font-size:28px;font-weight:900;background:linear-gradient(135deg,#ff2b2b,#7b2cff,#00d4ff)}
  h1{margin:0;font-size:34px;letter-spacing:-.8px}
  .tagline{margin:10px 0 0;color:#666;font-size:14px}
  .bar{height:7px;width:72%;margin:24px auto 0;background:linear-gradient(90deg,transparent,#ff2b2b,#7b2cff,#00d4ff);border-radius:99px}
  .title{text-align:center;padding:18px 0 8px}
  .title h2{margin:0;font-size:34px;letter-spacing:-.8px}
  .title p{margin:8px 0 0;color:#666;font-size:15px}
  .hero{margin:24px 0;padding:24px;border-radius:22px;background:linear-gradient(90deg,rgba(255,43,43,.10),rgba(123,44,255,.10),rgba(0,212,255,.08));border:1px solid #ececf0;display:flex;justify-content:space-between;gap:18px;align-items:center}
  .hero span{display:block;color:#666;font-size:13px;font-weight:700;text-transform:uppercase;letter-spacing:.04em}
  .hero strong{display:block;margin-top:6px;font-size:34px;color:#ff2532}
  .section{border-top:2px solid #202124;padding-top:22px;margin-top:26px}
  .section h3{margin:0 0 16px;font-size:24px}
  .grid{display:grid;grid-template-columns:1fr 1fr;gap:14px}
  .box{padding:15px;border:1px solid #e7e7ec;border-radius:16px;background:#fafafa}
  .box span{display:block;color:#666;font-size:12px;font-weight:700;text-transform:uppercase;margin-bottom:6px}
  .box strong,.box p{margin:0;font-size:15px;line-height:1.45}
  table{width:100%;border-collapse:collapse;margin-top:10px}
  th{font-size:12px;text-transform:uppercase;color:#666;text-align:left;padding:10px 0;border-bottom:1px solid #ddd}
  td{padding:15px 0;border-bottom:1px solid #ececf0;vertical-align:top;font-size:15px}
  td.price{text-align:right;font-weight:900;color:#ff2532;white-space:nowrap}
  .total{margin-top:18px;padding:18px;border-radius:18px;background:#f4f4f7;display:flex;justify-content:space-between;align-items:center;font-size:22px;font-weight:900}
  .total strong{color:#ff2532}
  .note{margin-top:18px;color:#666;font-size:13px;line-height:1.55}
  .footer{margin-top:28px;text-align:center;color:#777;font-size:12px;line-height:1.5}
  .actions{max-width:760px;margin:18px auto 28px;text-align:center}
  .btn{border:0;border-radius:999px;padding:13px 22px;background:linear-gradient(90deg,#ff2b2b,#7b2cff);color:#fff;font-weight:900;cursor:pointer;font-size:15px}
  @media print{body{background:#fff}.page{box-shadow:none;margin:0;border-radius:0}.actions{display:none}}
</style>
</head>
<body>
  <div class="page"><div class="topline"></div><div class="inner">
    <div class="header"><div class="logo">M</div><h1>MoRetro 3D</h1><p class="tagline">Créations 3D • Décorations • Mods console</p><div class="bar"></div></div>
    <div class="title"><h2>Devis personnalisé</h2><p>${quoteNumber} • ${created}</p></div>
    <div class="hero"><div><span>Prix final TTC</span><strong>${finalPrice}</strong></div><div style="text-align:right;color:#666;font-size:13px;line-height:1.45">Validité : 15 jours<br>Fabrication à la commande</div></div>
    <div class="section"><h3>Informations client</h3><div class="grid"><div class="box"><span>Client</span><strong>${clientName}</strong></div><div class="box"><span>Email</span><strong>${clientEmail}</strong></div><div class="box"><span>Téléphone</span><strong>${clientPhone || "Non renseigné"}</strong></div><div class="box"><span>Projet</span><strong>${projectName}</strong></div></div></div>
    <div class="section"><h3>Résumé du projet</h3><div class="box"><span>Description</span><p>${description || "Projet personnalisé selon la demande client."}</p></div></div>
    <div class="section"><h3>Détail du devis</h3><table><thead><tr><th>Prestation</th><th style="text-align:right">Prix</th></tr></thead><tbody><tr><td><strong>Création / impression 3D sur mesure</strong><br><span style="color:#666;font-size:13px">${fileName}</span></td><td class="price">${finalPrice}</td></tr></tbody></table><div class="total"><span>Total</span><strong>${finalPrice}</strong></div><p class="note">Les frais de livraison seront calculés automatiquement lors du paiement sur Shopify, après le choix du transporteur.</p></div>
    <div class="section"><h3>Informations techniques</h3><div class="grid"><div class="box"><span>Dimensions</span><strong>${dimensions}</strong></div><div class="box"><span>Poids</span><strong>${weight}</strong></div><div class="box"><span>Temps</span><strong>${time}</strong></div><div class="box"><span>Fichier</span><strong>${fileName}</strong></div></div></div>
    <div class="footer">MoRetro 3D — Fabrication à la commande<br>Ce devis est indicatif jusqu’à validation finale du projet et paiement.</div>
  </div></div>
  <div class="actions"><button class="btn" onclick="window.print()">Imprimer / enregistrer en PDF</button></div>
</body>
</html>`;
  }

  function openQuoteDocument(project){
    const data = MTS.state.lastAutoQuote || project.autoQuote;
    if(!data){
      alert("Calcule et enregistre d'abord un devis.");
      return;
    }

    const win = window.open("", "_blank", "width=900,height=1100");
    if(!win){
      alert("Popup bloquée. Autorise les popups pour générer le devis.");
      return;
    }

    win.document.open();
    win.document.write(buildQuoteHtml(project, data));
    win.document.close();
  }

  function getCurrentQuote(project){
    const hasQuoteDom = !!document.getElementById("mtsAnalysisCard");
    if(hasQuoteDom){
      try{
        return buildAutoQuote(project || {});
      }catch(err){
        console.warn("Lecture devis courant impossible :", err.message);
      }
    }
    return MTS.state.lastAutoQuote || project?.autoQuote || null;
  }

  function bind(project){
    MTS.state.lastAutoQuote = project.autoQuote || null;

    [
      "mtsManualFileSelect","mtsManualX","mtsManualY","mtsManualZ","mtsManualWeight","mtsManualHours","mtsManualMinutes",
      "mtsAutoMaterial","mtsAutoFilament","mtsAutoPrinter","mtsFilamentKgPrice","mtsElectricityHourly","mtsLaborFixed",
      "mtsMarginPercent","mtsFinalPrice"
    ].forEach(id=>{
      const el = MTS.$(id);
      if(el) el.addEventListener(el.tagName==="SELECT" ? "change" : "input", ()=>{
        if(id === "mtsAutoMaterial" && MTS.Settings && typeof MTS.Settings.kgPriceFor === "function"){
          const kg = MTS.$("mtsFilamentKgPrice");
          if(kg) kg.value = MTS.Settings.kgPriceFor(el.value);
        }
        if(id === "mtsAutoFilament" && MTS.Settings && typeof MTS.Settings.filamentById === "function"){
          const f = MTS.Settings.filamentById(el.value);
          if(f){
            const mat = MTS.$("mtsAutoMaterial");
            const kg = MTS.$("mtsFilamentKgPrice");
            if(mat) mat.value = f.material || mat.value;
            if(kg) kg.value = Number(f.kgPrice || f.literPrice || kg.value || 0);
          }
        }
        refresh(project);
      });
    });

    MTS.on("mtsAnalyzeFile","click",()=>refresh(project));

    MTS.on("mtsSaveAutoQuote","click",async()=>{
      try {
        await save(project.id);
        MTS.state.activeProjectTab = "files";
        if(MTS.Projects && typeof MTS.Projects.renderDetail === "function") MTS.Projects.renderDetail(project);
        alert("Devis enregistré dans Fichiers.");
      }
      catch(err){ alert("Erreur : " + err.message); }
    });

    MTS.on("mtsGenerateQuotePdf","click",async()=>{
      try{
        refresh(project);
        await save(project.id);
      }catch(err){
        console.warn("PDF généré sans sauvegarde Firestore :", err.message);
      }
      openQuoteDocument(project);
    });
  }

  MTS.Quotes = {renderQuoteBox, bind, refresh, analyzeProject, save, openQuoteDocument, buildQuoteHtml, getCurrentQuote};
})(window.MTS);

